import { render, staticRenderFns } from "./newAcg.vue?vue&type=template&id=b2dce298&scoped=true&"
import script from "./newAcg.vue?vue&type=script&lang=js&"
export * from "./newAcg.vue?vue&type=script&lang=js&"
import style0 from "./newAcg.vue?vue&type=style&index=0&id=b2dce298&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dce298",
  null
  
)

export default component.exports